import React, { useState } from "react";
import "./BrandingAdvertising.css";

// Images
import bags from "../assets/BAGS.png";
import p3 from "../assets/P3.png";
import p4 from "../assets/P4.png";
import p7 from "../assets/P7.png";
import p8 from "../assets/P8.jpg";
import p10 from "../assets/P10.jpg";
import p12 from "../assets/P12.jpg";
import p37 from "../assets/P37.png";
import p39 from "../assets/P39.png";

const BrandingAdvertising = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  const brandingImages = [
    bags,
    p3,
    p4,
    p7,
    p8,
    p10,
    p12,
    p37,
    p39,
  ];

  return (
    <section className="service-page">
      <div className="service-hero">
        <h1>Branding & Advertising</h1>        
      </div>

      <div className="service-content">        
        {/* IMAGE GRID */}
        <div className="image-gallery">
          {brandingImages.map((img, index) => (
            <div
              className="image-card"
              key={index}
              onClick={() => setSelectedImage(img)}
            >
              <div className="image-wrapper">
                <img src={img} alt={`Branding sample ${index + 1}`} />
              </div>
              <div className="image-overlay">
                <span>View</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* MODAL */}
      {selectedImage && (
        <div className="image-modal" onClick={() => setSelectedImage(null)}>
          <img src={selectedImage} alt="Selected branding work" />
          <span className="close-btn">&times;</span>
        </div>
      )}
    </section>
  );
};

export default BrandingAdvertising;
